module.exports = __webpack_public_path__ + "img/interactivevoiceresponse.b9fa1385.jpg";